// extracted by mini-css-extract-plugin
export default {"modal":"S3-z","outfitSelector":"T3-z","outfitHeading":"U3-z","itemContainer":"V3-z","item":"W3-z","selected":"X3-z"};